import { baseUrl } from "../Api";

export const URL_SPECIALITY = baseUrl + "/speciality";

export const URL_SPECIALITY_STATUS = baseUrl + "/speciality/status";
